export default __webpack_public_path__ + "static/media/2.b436362e.jpg";